module.exports = __webpack_public_path__ + "static/media/emblemaTAOD.c87b9462.jpg";